import { CatalogReducer, CatalogSuggestionsProductParams } from './interfaces';

export const setCatalogLoading = (loading: CatalogReducer['loading']) => ({
	type: 'SET_CATALOG_LOADING',
	payload: { loading },
});

export const setCatalogMenuItems = (catalogMenuItems: CatalogReducer['catalogMenuItems']) => ({
	type: 'SET_CATALOG_MENU_ITEMS',
	payload: { catalogMenuItems },
});

export const setSuggestionsProductNotifierExpiration = (notifierExpiration: CatalogSuggestionsProductParams) => ({
	type: 'SET_SUGGESTIONS_PRODUCT_NOTIFIER_EXPIRATION',
	payload: { notifierExpiration },
});

export const clearSuggestionsProductNotifierExpiration = () => ({
	type: 'CLEAR_SUGGESTIONS_PRODUCT_NOTIFIER_EXPIRATION',
});

export const setLoadingPromotionDetails = (loading: CatalogReducer['promotionDetails']['loading']) => ({
	type: 'SET_CATALOG_LOADING_PROMOTION_DETAILS',
	payload: { loading },
});

export const setIsPromotionActive = (state: CatalogReducer['isPromotionActive']) => ({
	type: 'SET_IS_PROMOTION_ACTIVE',
	payload: {
		state,
	},
});

export const setIncentiveCampaignFlags = (flags: CatalogReducer['incentiveCampaignFlags']) => ({
	type: 'SET_INCENTIVE_CAMPAIGN_FLAGS',
	payload: {
		flags,
	},
});

export const setIncentiveCurrentCampaignLoading = (loading: boolean) => ({
	type: 'SET_INCENTIVE_CURRENT_CAMPAIGN_LOADING',
	payload: {
		loading,
	},
});

export const setIncentiveCurrentCampaignFetched = (fetched: boolean) => ({
	type: 'SET_INCENTIVE_CURRENT_CAMPAIGN_FETCHED',
	payload: {
		fetched,
	},
});

export const setIncentiveCurrentCampaignData = (data: CatalogReducer['incentiveCurrentCampaignData']) => ({
	type: 'SET_INCENTIVE_CURRENT_CAMPAIGN_DATA',
	payload: {
		data,
	},
});

export const clearCatalog = () => ({
	type: 'CLEAR_CATALOG',
});
